
export class SummaryViewController {

    constructor($log, $window, $analytics, AppConfig, UserSessionService, QuoteRequestService, EmailDesignService, PrintDesignService) {
        'ngInject';

        this.$log = $log;
        this.$window = $window;
        this.$analytics = $analytics;
        this.appConfig = AppConfig;
        this.userSessionService = UserSessionService;
        this.quoteRequestService = QuoteRequestService;
        this.emailDesignService = EmailDesignService;
        this.printDesignService = PrintDesignService;

        this.shownImage = 'after';
        this.beforeImage = this.userSessionService.getBaseImage();
        this.afterImage = this.userSessionService.getRenderedImage();
        this.data = this.userSessionService.getData();
        this.printing = false;
    }

    $onInit() {
        this.image = this.userSessionService.getImage();
        this.doors = this.userSessionService.getDoors();
    }

    getImage() {

        return (this.shownImage === 'before') ? this.beforeImage : this.afterImage;

    }

    showImage(val) {
        this.shownImage = val;
    }

    getDoors() {
        return this.doors;
    }

    requestQuote() {
        this.quoteRequestService.open();
    }

    sendEmail() {
        this.emailDesignService.open();
    }

    print() {

        this.printing = true;

        this.$analytics.pageTrack('/print-design');
        this.$analytics.eventTrack('download', {  category: 'Print design' });

        this.userSessionService.downloadDesign().then((response) => {
            var byteCharacters = atob(response);
            var byteNumbers = new Array(byteCharacters.length);
            for (var i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            var byteArray = new Uint8Array(byteNumbers);

            const blob = new Blob([byteArray], {type: 'application/pdf'});

            saveAs(blob, 'design.pdf');

            this.printing = false;
        });

    }

}



// WEBPACK FOOTER //
// ./src/js/views/summary-view/summary-view.controller.js